module.exports = require("compression");


//////////////////
// WEBPACK FOOTER
// external "compression"
// module id = 9
// module chunks = 0